import "../manage.css";
import { useEffect, useState } from "react";
import axios from "axios";
import { useNavigate } from "react-router-dom";

const ManageRoles = () => {
  const [roles, setRoles] = useState([]);
  const [search, setSearch] = useState("");
  const [loading, setLoading] = useState(false);

  const navigate = useNavigate();

  useEffect(() => {
    const fetchRoles = async () => {
      try {
        setLoading(true);

        const token = localStorage.getItem("token");

        const response = await axios.get(
          "https://api.arkiva.gov.al/api/roles",
          {
            headers: {
              Authorization: `Bearer ${token}`,
            },
          },
        );

        setRoles(response.data);
      } catch (error) {
        console.error("Error fetching roles:", error);
      } finally {
        setLoading(false);
      }
    };

    fetchRoles();
  }, []);

  const editRole = (role) => {
    navigate(`/manage/roles/${role._id}`);
  };

  const addRole = () => {
    navigate("/manage/roles/add-new");
  };

  const deleteRole = async (role) => {
    const confirmDelete = window.confirm(
      `Jeni i sigurt që dëshironi të fshini rolin "${role.name}"?`,
    );

    if (!confirmDelete) return;

    try {
      setLoading(true);

      const token = localStorage.getItem("token");

      await axios.delete(
        `https://api.arkiva.gov.al/api/roles/delete/${role._id}`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        },
      );

      setRoles((prevRoles) =>
        prevRoles.filter((item) => item._id !== role._id),
      );
    } catch (error) {
      console.error("Error deleting role:", error);

      alert(
        error.response?.data?.message ||
          "Ndodhi një gabim gjatë fshirjes së rolit.",
      );
    } finally {
      setLoading(false);
    }
  };

  const filteredRoles = roles.filter((role) =>
    role.name.toLowerCase().includes(search.toLowerCase()),
  );

  return (
    <div className="manage-page">
      {loading && (
        <div className="overlay">
          <div className="spinner"></div>
        </div>
      )}

      <div className="manage-page-header">
        <div className="manage-page-header-actions">
          <input
            type="text"
            placeholder="Search"
            value={search}
            onChange={(e) => setSearch(e.target.value)}
          />

          <button onClick={addRole}>
            <i className="fa-solid fa-plus"></i> Shto Rol
          </button>
        </div>
      </div>

      <div className="manage-table">
        <table className="table">
          <thead>
            <tr>
              <th>Roli</th>
              <th>Akses</th>
              <th>Veprime</th>
            </tr>
          </thead>

          <tbody>
            {filteredRoles.length > 0 ? (
              filteredRoles.map((role) => (
                <tr key={role._id}>
                  <td data-label="Roli">{role.name}</td>

                  <td data-label="Akses">
                    {role.access?.length > 0
                      ? role.access.join(", ")
                      : "Nuk ka akses"}
                  </td>

                  <td className="actions" data-label="Veprime">
                    <button onClick={() => editRole(role)}>
                      <i className="fa-solid fa-pen-to-square"></i>
                    </button>

                    <button onClick={() => deleteRole(role)}>
                      <i className="fa-solid fa-trash"></i>
                    </button>
                  </td>
                </tr>
              ))
            ) : (
              <tr>
                <td colSpan="3">Nuk u gjetën role!</td>
              </tr>
            )}
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default ManageRoles;
